import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const ArrowRightIcon: React.FC<Props> = ({
  color = '#1C1C1F',
  width = 18,
  height = 18,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
  >
    <path
      d="M11.761 5.21045L14.7354 8.33003C15.0882 8.7 15.0882 9.29984 14.7354 9.66981L11.761 12.7894M14.4709 8.99993H6.1579"
      stroke={color}
      strokeWidth="1.26316"
      strokeLinecap="round"
    />
    <path
      d="M3 4.36865L3 13.6318"
      stroke={color}
      strokeWidth="1.26316"
      strokeLinecap="round"
    />
  </svg>
);
